import React, { useEffect } from 'react';
import { V2ModalDialog } from '@uhg-abyss/web/ui/ModalDialog';
import { V2Button } from '@uhg-abyss/web/ui/Button';
import { storage } from '@uhg-abyss/web/tools/storage';
import PropTypes from 'prop-types';
import { useUser } from '@src/state/user';
import { config } from '@uhg-abyss/web/tools/config';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { HAS_SIGNED_OUT } from './constants';
import { Countdown } from './Countdown';

let timeLeft;
let modelOpen;

export const UserBlockedModal = ({
  events,
  isOpen,
  closeModal,
  timeRemaining,
}) => {
  const { uuid } = useUser.state();
  const isSuperUser = storage.local.get(uuid);
  const handleSignout = () => {
    storage.local.set(HAS_SIGNED_OUT, true);
    if (config('US3671382_SUPER_USER') && isSuperUser) {
      storage.local.remove(uuid);
    }
    events.onSignout();
  };

  useEffect(() => {
    timeLeft = timeRemaining;
  }, [timeRemaining]);

  useEffect(() => {
    modelOpen = false;
  }, []);

  useEffect(() => {
    timeLeft = timeRemaining;
    modelOpen = isOpen;
  }, [isOpen]);

  const handleTimeout = () => {
    closeModal();
  };

  return (
    <V2ModalDialog
      size="600px"
      isOpen={modelOpen}
      header="Too Many Failed Attempts"
      closeOnClickOutside={false}
    >
      <div>
        User locked out due to invalid attempts. Please try again in one hour.
      </div>
      <div>
        Time remaining:{' '}
        {<Countdown countdownMS={timeLeft} onComplete={handleTimeout} />}
      </div>
      <Layout.Group alignLayout="right" css={{ marginTop: '24px' }}>
        <V2Button variant="outline" onClick={handleSignout}>
          Sign Out
        </V2Button>
        <V2Button onClick={closeModal}>Continue Working</V2Button>
      </Layout.Group>
    </V2ModalDialog>
  );
};

UserBlockedModal.propTypes = {
  timeRemaining: PropTypes.number,
  events: PropTypes.shape({
    onSignout: PropTypes.func,
  }).isRequired,
  isOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
};

UserBlockedModal.defaultProps = {
  timeRemaining: 600000,
};
